import React, { useState, useEffect } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import {
  drawerWidth,
  mainLayoutStyles,
  showNotification,
} from "../../../../constants";
import Header from "../../../../common/Header";
import Sidebar from "../../../../common/Sidebar";
import {
  FilterSection,
  ReactionsTable,
  SearchBar,
} from "../../components/components";
import {
  ReactionsSearch,
  deleteReaction,
  getFilterOrgReactions,
  updateReaction,
} from "../../hooks/ReactionsHooks";
import { useReactionsContext } from "../../../../providers/OrganizationAdmin/ReactionsProvider";
import { Toast } from "../../../../common/alert";
import { useAuth } from "../../../../hooks";
import ConfirmationModal from "../../../../common/ConfirmationModal";
import FilterModalComponent from "../../../../common/FilterModalComponent";
import { getDateRange } from "../../../OrgProf/hook/Organizationhook";

const ReactionsContainer = () => {
  const { currentUser, organizationId } = useAuth();
  const { handleGetAllReactions, allReactions, loading, setLoading } =
    useReactionsContext();

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [creationDateFilterOptions, setCreationDateFilterOptions] = useState(
    []
  );

  const [reactionsInOrg, setReactionsInOrg] = useState([]);

  useEffect(() => {
    handleGetAllReactions();
    // if (allReactions?.length) {
    // } else {
    //   handleGetAllReactions();
    // }
  }, []);

  useEffect(() => {
    setReactionsInOrg(allReactions);
  }, [allReactions]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };
  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };
  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const handleDeleteReaction = async () => {
    try {
      setLoading(true);

      selected.forEach(async (item) => {
        let responseTemp = await deleteReaction(item);
        console.log("delete reaction response:", responseTemp);
      });
      await handleGetAllReactions();
      setSelected([]);
      showNotification("Reaction deleted successfully.");
      // Toast("success", "Reaction deleted successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error deleting reaction", error.message);
    } finally {
      setLoading(false);
      handleDeleteModalClose();
    }
  };

  const handleUpdateReactionStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateReaction(item, dataTemp);
        console.log("update reaction response:", responseTemp);
      });
      await handleGetAllReactions();
      setSelected([]);
      showNotification("Reaction updated successfully.");
      // Toast("success", "reaction updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating reaction", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterReactions = async () => {
    let creationDateRange;
    if (creationDateFilterOptions && creationDateFilterOptions.length > 0) {
      creationDateRange = getDateRange(creationDateFilterOptions);
    }
    setSelected([]);
    if (
      creationDateFilterOptions.length > 0 ||
      statusFilterOptions.length > 0
    ) {
      let temp = await getFilterOrgReactions(
        statusFilterOptions,
        // creationDateFilterOptions,
        creationDateRange,
        setLoading,
        handleFilterModalClose,
        organizationId ? organizationId : currentUser.organization
      );
      setReactionsInOrg([...temp]);
    }
    if (
      creationDateFilterOptions.length === 0 &&
      statusFilterOptions.length === 0
    ) {
      setReactionsInOrg(allReactions);
    }
  };

  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "status") {
      setStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "creationDate") {
      setCreationDateFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    }
  };

  useEffect(() => {
    handleFilterReactions();
  }, [statusFilterOptions, creationDateFilterOptions]);

  const handleSearchReactions = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        // setSearchValue(value);
        // console.log(value);
        let reactionsSearchTemp = await ReactionsSearch(allReactions, value);
        setReactionsInOrg(reactionsSearchTemp);
      } else {
        setReactionsInOrg(allReactions);
        // setSearchValue(null);
      }
    } catch (error) {
      console.log("error searching quicktales:", error.message);
    }
  };

  const resetFilter = async () => {
    setCreationDateFilterOptions([]);
    setStatusFilterOptions([]);
    setReactionsInOrg(allReactions);
    setSelected([]);
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header mainTitle={"Reactions in Organization"} bgColor="#fff" />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            statusFilterOptions={statusFilterOptions}
            creationDateFilterOptions={creationDateFilterOptions}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            selected={selected}
            setSelected={setSelected}
            placeholder={"Search QT Title, Reaction By, QT Created By"}
            handleSearch={handleSearchReactions}
            handleUpdateReactionStatus={handleUpdateReactionStatus}
            handleDeleteReaction={handleDeleteModalOpen}
          />

          <ReactionsTable
            selected={selected}
            setSelected={setSelected}
            reactionsInOrg={reactionsInOrg}
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteReaction}
        title={"Are you sure to delete the selected Reaction(s)?"}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterReactions}
        data={[
          {
            mainOptions: statusFilterOptions,
            setMainOptions: setStatusFilterOptions,
            type: "text",
            title: "Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "pending", selected: false },
              { label: "approved", selected: false },
              { label: "denied", selected: false },
              { label: "removed", selected: false },
            ],
          },
          {
            mainOptions: creationDateFilterOptions,
            setMainOptions: setCreationDateFilterOptions,
            type: "date",
            title: "Creation Date",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default ReactionsContainer;
